import { useSelector } from 'react-redux';
import { Divider } from '@vinted/web-ui';
import classNames from 'classnames';
import { CookieConsentVersion } from 'constants/consent';
import { BUSINESS_TERMS_OF_SALE_URL, BUSINESS_TERMS_URL, COOKIE_POLICY_URL, OUR_PLATFORM_URL, PRIVACY_POLICY_URL, TERMS_URL } from 'constants/routes';
import useTranslate from 'hooks/useTranslate';
import { getOldHostRedirectUrl } from 'libs/utils/url';
import { toggleOneTrustInfoDisplay } from 'libs/utils/window';
import * as consentSelectors from 'state/consent/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const PolicyFooter = _ref => {
  let {
    isDigitalLawEnabled,
    isBusinessInfoLinksEnabled,
    onlineComplaintUrl,
    isStatic,
    noDivider
  } = _ref;
  const translate = useTranslate('footer.policy.items');
  const isCookieConsentVersion = useSelector(consentSelectors.getIsCookieConsentVersion);
  const cookieConsentVersion = useSelector(consentSelectors.getCookieConsentVersion);
  const className = classNames('privacy-footer', isStatic && 'privacy-footer--static');
  const cookieSettingsText = cookieConsentVersion === CookieConsentVersion.California ? translate('cookie_settings_us') : translate('cookie_settings');

  function handleCookieSettingsClick() {
    toggleOneTrustInfoDisplay();
  }

  return /*#__PURE__*/_jsx("footer", {
    className: className,
    children: /*#__PURE__*/_jsx("div", {
      className: "privacy-footer__content",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container",
        children: [!noDivider && /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("div", {
          className: "privacy-footer__content__links",
          children: [/*#__PURE__*/_jsx("a", {
            href: getOldHostRedirectUrl() + PRIVACY_POLICY_URL,
            children: translate('privacy_policy')
          }), /*#__PURE__*/_jsx("a", {
            href: COOKIE_POLICY_URL,
            children: translate('cookie_policy')
          }), isCookieConsentVersion && /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: handleCookieSettingsClick,
            children: cookieSettingsText
          }), /*#__PURE__*/_jsx("a", {
            href: TERMS_URL,
            children: translate('terms_and_conditions')
          }), isDigitalLawEnabled && /*#__PURE__*/_jsx("a", {
            href: OUR_PLATFORM_URL,
            children: translate('our_platform')
          }), isBusinessInfoLinksEnabled && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("a", {
              href: BUSINESS_TERMS_OF_SALE_URL,
              "data-testid": "privacy-footer-pro-sale-term-link",
              children: translate('pro_terms_of_sale')
            }), /*#__PURE__*/_jsx("a", {
              href: BUSINESS_TERMS_URL,
              "data-testid": "privacy-footer-pro-use-term-link",
              children: translate('pro_terms_of_use')
            })]
          }), onlineComplaintUrl && /*#__PURE__*/_jsx("a", {
            href: onlineComplaintUrl,
            children: translate('online_complaints')
          })]
        })]
      })
    })
  });
};

export default PolicyFooter;